/* eslint-disable import-x/no-default-export */
import Chance from 'chance';

const chance = new Chance();

export default () =>
  chance.pickone([
    {
      id: 1002,
      description: 'Melbourne',
      subLocation: null,
    },
    {
      id: 3101,
      description: 'New South Wales',
      subLocation: {
        id: 5026,
        description: 'Albury Area',
      },
    },
    {
      id: 1019,
      description: 'Wellington',
      subLocation: null,
    },
    {
      id: 5161,
      description: 'London',
      subLocation: null,
    },
    {
      id: 5140,
      description: 'Asia Pacific',
      subLocation: null,
    },
  ]);
